module.exports = __webpack_public_path__ + "img/nero.e4542026.jpg";